/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { DashboardConfigControllerService } from './services/dashboard-config-controller.service';
import { MySvgControllerService } from './services/my-svg-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    DashboardConfigControllerService,
    MySvgControllerService,
    ApiConfiguration
  ],
})
export class DashboardConfigModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<DashboardConfigModule> {
    return {
      ngModule: DashboardConfigModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: DashboardConfigModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('DashboardConfigModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
